


























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import ContinuousEntry from "@/models/progress/continuous-entry";
import GlobalMixin from "@/mixins";

@Component({
    components: {}
})
export default class ProgressContinuous extends GlobalMixin {

    public maxValue: number = 60;

    @Prop({
        default: ''
    })
    public unit!: string;

    @Prop()
    public goalDetails: any;

    @Prop({
      default: false
    })
    public debug!: boolean;

    @Prop({
        default: []
    })
    public entries!: ContinuousEntry[];

    public selectedFeedbackIndex: any = null;

    @Watch('entries')
    public onEntriesChange(value: string, oldValue: string) {
        this.initialize();
    }

    get websiteId() {
        return this.$store.state.data ? this.$store.state.data.website_id : '';
    }

    public selectFeedback(index: number) {
        if (this.entries[index].value_label || true) {
            this.selectedFeedbackIndex = index;
        }
        this.track('Goal Day Toggle', this.goalDetails.goal, 'Day' + (index + 1), this.websiteId);
    }

    private fillStyleForEntry(entry: ContinuousEntry) {
        return {
            height: ((parseInt(entry.value, 10) / this.maxValue) * 100) + '%'
        }
    }

    private initialize() {
        this.selectedFeedbackIndex = this.entries.length - 1;

        /*
        let i = this.entries.length - 1;
        while ((!this.entries[i].feedback || !this.entries[i].feedback_label) && i > 0) {
            i--;
        }
        if (this.entries[i].feedback && this.entries[i].feedback_label) {
            this.selectedFeedbackIndex = i;
        }
         */

        this.maxValue = 0;
        for (const entry of this.entries) {
            if (parseInt(entry.value, 10) > this.maxValue) {
                this.maxValue = parseInt(entry.value, 10);
            }
        }
        if (!this.maxValue) {
            this.maxValue = 60;
        }
        else {
            this.maxValue = Math.floor(this.maxValue * 1.3);
        }
    }


    private mounted() {
        this.initialize();
    }

}
